import type { ParsedToken, User as FirebaseUser } from 'firebase/auth';
import React from 'react';

type UserContextType = {
  loggingIn: boolean;
  user: FirebaseUser | undefined;
  loading: boolean;
  userData: introwise.User | undefined;
  claims: ParsedToken | undefined;
  claimsLoading: boolean;
};

const initialUserContext: UserContextType = {
  loggingIn: true,
  user: undefined,
  loading: true,
  userData: undefined,
  claims: undefined,
  claimsLoading: true,
};

const UserContext = React.createContext(initialUserContext);

export { initialUserContext, type UserContextType };
export default UserContext;
